import { Fab, Stack, useTheme } from "@mui/material";
import React, { useCallback } from "react";
import { FabExtend, Icone, InputBusca } from "../../../components";
import { useDispatch } from "react-redux";
import { cashbackSetModal } from "./reducers/cashback-actions";
import CashbackModal from "./cashback-modal";

const STR = {
  labelBtnNew: "Criar Voucher Manual",
  titleBtnNew:
    "Clique aqui caso deseje criar um novo voucher para um cliente manualmente",
};
//
function CashbackPanel({
  filter,
  setFilter,
  onAdd,
  color,
  icon,
  title,
  label,
  noViewSearchBar,
  viewButtonAdd,
}) {
  const dispatch = useDispatch();
  const isMobile = useTheme()?.isMobile;
  const onNewCashback = useCallback(() => {
    dispatch(cashbackSetModal({ type: CashbackModal.modal.NEW_CASHBACK }));
  }, [dispatch]);

  return (
    <Stack direction="row-reverse" gap={isMobile ? 0 : 1.5} alignItems="center">
      {noViewSearchBar ? (
        <Stack flex={1} />
      ) : (
        <InputBusca
          fullWidth
          sx={{ mb: 1 }}
          variant="filled"
          label=""
          filtro={filter}
          setFiltro={setFilter}
          desativarPesquisaLenta
        />
      )}
      {viewButtonAdd && (
        <Fab
          title={STR.titleBtnNew}
          size="medium"
          onClick={onNewCashback}
          variant="extended"
          color="success"
        >
          <Icone icone="FiberNew" />
          &nbsp;{STR.labelBtnNew}
        </Fab>
      )}
      <FabExtend
        icone={icon}
        color={color}
        title={title}
        text={label}
        onClick={onAdd}
      />
    </Stack>
  );
}

export default CashbackPanel;
